var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaverse6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20C20 15.5817 16.4183 12 12 12C7.58172 12 4 15.5817 4 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4697 3.46967C18.7626 3.17678 19.2374 3.17678 19.5303 3.46967L21.5303 5.46967C21.8232 5.76256 21.8232 6.23744 21.5303 6.53033L19.5303 8.53033C19.2374 8.82322 18.7626 8.82322 18.4697 8.53033C18.1768 8.23744 18.1768 7.76256 18.4697 7.46967L19.9393 6L18.4697 4.53033C18.1768 4.23744 18.1768 3.76256 18.4697 3.46967Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46967 3.46967C4.76256 3.17678 5.23744 3.17678 5.53033 3.46967C5.82322 3.76256 5.82322 4.23744 5.53033 4.53033L4.06066 6L5.53033 7.46967C5.82322 7.76256 5.82322 8.23744 5.53033 8.53033C5.23744 8.82322 4.76256 8.82322 4.46967 8.53033L2.46967 6.53033C2.17678 6.23744 2.17678 5.76256 2.46967 5.46967L4.46967 3.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse6);
export default __webpack_public_path__ + "static/media/metaverse-6.ceb7c810f2e5a1fba8d3bb060d56bd3d.svg";
export { ForwardRef as ReactComponent };